// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"296ae20b","744":"f1e78c27"}[chunkId] + ".css";
};